import Logo from "../../components/icons/Logo";
import Tap from "../../assets/img/Green-Touch-Icon.gif";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../context/DataProvider";
import { useCallback } from "react";
import { Header } from "../../components/Header";
import Seats from "../../components/icons/NavIcons/Seating";
import Concessions from "../../components/icons/NavIcons/Concessions";

const AthleticsPage = () => {
    const navigate = useNavigate();
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent, location])
    return (
      <div className="page splash athleticsPage">
        <Header />
        <div className="page-header">Athletics</div>
        <div className="text-blocks">
          <div className="std-text">
            Create distinctive, personalized experiences for 
            students through innovative point-of-sale payments, 
            kiosk, and mobile ordering designed specifically for 
            stadiums & arenas dining.{'\n\n'}

            These solutions help automate many of the labor-intensive 
            transactional tasks, freeing up staff to spend 
            more quality time focused on delivering a more 
            personalized, higher touch dining experience.
          </div>
        </div>
        <div
          className="logo"
          onClick={() => {
            _logEvent("click", "Athletics", "Agilysys");
            addFlow("Agilysys");
            navigate("/aboutus/agilysys");
          }}
        >
          <Logo />
        </div>
        <div className="athletics-map">
          <div className="seats">
            <Seats
              onClick={() => {
                _logEvent("click", "Athletics", "Seats");
                addFlow("Seats");
                navigate("seats", { relative: "path" });
              }}
            />
          </div>
          <div className="concessions">
            <Concessions
              onClick={() => {
                _logEvent("click", "Athletics", "Concessions");
                addFlow("Concessions");
                navigate("concessions", { relative: "path" });
              }}
            />
          </div>
        </div>
        <div className="tap">
          <img src={Tap} alt="" />
          <div className="tap-prompt">
            Tap on each section of the map{"\n"}
            To drill into the details
          </div>
        </div>
      </div>
    );
}

export default AthleticsPage;